import { colors } from '@theme/variables'

interface ArrowRightProps {
  disabled?: boolean
}

const ArrowRight = ({ disabled }: ArrowRightProps) => {
  return (
    <svg width="37" height="90" viewBox="0 0 37 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.72168 0.691406H14.4723L36.7217 44.9991H22.971L0.72168 0.691406Z" fill={disabled ? '#E8E8E8' : colors.primary} />
      <path d="M36.7217 45H22.971L0.72168 89.3077H14.4723L36.7217 45Z" fill={disabled ? '#E8E8E8' : colors.primary} />
    </svg>
  )
}

export default ArrowRight
